import { z } from "zod";
import { BlockPath } from "../generated/storyblok/blockPaths";

export enum FeedScope {
  News = "news",
}

export const blockPathsPerFeed = {
  [FeedScope.News]: [
    BlockPath.FoundationsBusinessSector,
    BlockPath.FoundationsProductType,
    BlockPath.CustomerAudienceLocation,
  ],
};

export const FeedEntrySourceSchema = z.object({
  sourceUrl: z.string().optional().describe("URL of the source"),
  title: z.string().optional().describe("Headline of the source found"),
  author: z
    .string()
    .optional()
    .describe("Author of the article or company name that created the entry"),
  mediaType: z
    .string()
    .optional()
    .describe("Type of resource (article, post, auto-generated, etc.)"),
  mediaFormat: z
    .string()
    .optional()
    .describe("Format of the content (text, audio, image, video, etc.)"),
});

export const FeedEntryGeneratedSchema = z.object({
  feedEntries: z.array(
    FeedEntrySourceSchema.extend({
      content: z.string().describe("First lines of the source content"),
      publishedAt: z
        .string()
        .optional()
        .describe(
          "Publication date of the entry in the format of YYYY-MM-DD or empty string if none",
        ),
    }),
  ),
});

export const FeedEntryFilterSchema = z.object({
  scope: z.nativeEnum(FeedScope),
});

export type FeedEntrySource = z.infer<typeof FeedEntrySourceSchema>;
export type FeedEntryGenerated = z.infer<typeof FeedEntryGeneratedSchema>;
export type FeedEntryFilter = z.infer<typeof FeedEntryFilterSchema>;
